import { useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AvailabilityFormFinder } from "./form/AvailabilityFormFinder";
import { AvailabilityResults } from "./list/AvailabilityResults";
import { AvailabilityPreferences, AvailabilitySlot, PriorityData, WeeklyAvailabilityFromApi } from "../utils/types";
import { useForm } from "react-hook-form";

export const AvailabilityFinder = () => {
    const entityForm = useForm<AvailabilityPreferences>({
        defaultValues: {
            clinic_id: undefined,
            startDate: new Date(),
            dayPeriod: "both",
            preferredDays: [],
            treatment: undefined,
            lead: undefined,
            firstService: undefined,
            firstServiceTechnician: undefined,
            requireConsecutiveSessions: false,
            secondService: undefined,
            secondServiceTechnician: undefined,
            age_groups: undefined,
            disorder_specialization: undefined,
        },
    });
    const [preferences, setPreferences] = useState<AvailabilityPreferences | null>(null);
    const [selectedSlots, setSelectedSlots] = useState<AvailabilitySlot[]>([]);
    const [weeks, setWeeks] = useState<WeeklyAvailabilityFromApi[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [prioritiesData, setPrioritiesData] = useState<PriorityData | undefined>();

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box sx={{ p: 3 }}>
                <Paper sx={{ p: 3, mb: 3 }}>
                    <Typography variant="h5" color="primary" mb={6} ml={1}>
                        Encontrar Disponibilidades para Sessões
                    </Typography>

                    <AvailabilityFormFinder
                        setIsLoading={setIsLoading}
                        entityForm={entityForm}
                        selectedSlots={selectedSlots}
                        setSelectedSlots={setSelectedSlots}
                        setWeeks={setWeeks}
                        isLoading={isLoading}
                        setPreferences={setPreferences}
                        setPrioritiesData={setPrioritiesData}
                    />
                </Paper>

                {preferences && weeks.length > 0 && (
                    <AvailabilityResults
                        preferences={preferences}
                        selectedSlots={selectedSlots}
                        setSelectedSlots={setSelectedSlots}
                        weeks={weeks}
                        setWeeks={setWeeks}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        prioritiesData={prioritiesData}
                    />
                )}
            </Box>
        </LocalizationProvider>
    );
};
